export const ASSIGNEE_KIND_OPTIONS = [
  { label: 'Employee', value: 'employee' },
  { label: 'Service Provider', value: 'service_provider' },
  { label: 'Vendor', value: 'vendor' }
];

export const ASSIGNEE_REQUIRED_MESSAGE = 'Select an assignee';

export function assigneeKindFromApi(row) {
  return row?.assigneeKind || 'employee';
}

function positiveId(raw) {
  const n = Number(raw);
  return Number.isInteger(n) && n > 0 ? n : null;
}

export function hasAssignee(kind, values) {
  if (kind === 'service_provider') return !!positiveId(values?.assignedTo_sp_id);
  if (kind === 'vendor') return !!positiveId(values?.assignedTo_vendor_id);
  return !!positiveId(values?.assignedTo_id);
}

export function assigneePayload(kind, values) {
  if (kind === 'service_provider') {
    const id = positiveId(values.assignedTo_sp_id);
    return id ? { assignedTo_sp_id: id } : {};
  }
  if (kind === 'vendor') {
    const id = positiveId(values.assignedTo_vendor_id);
    return id ? { assignedTo_vendor_id: id } : {};
  }
  const id = positiveId(values.assignedTo_id);
  return id ? { assignedTo_id: id } : {};
}

export function assigneeKindLabel(kind) {
  if (kind === 'service_provider') return 'Service Provider';
  if (kind === 'vendor') return 'Vendor';
  return '';
}

const SUBTASK_STAFF_VERTICALS = new Set(['sales', 'operations', 'inventory']);

export function isSubtaskStaffVertical(user) {
  return SUBTASK_STAFF_VERTICALS.has(String(user?.vertical || '').toLowerCase());
}

function staffOptionFromUser(user) {
  return {
    label: `${user.name || user.userName || 'User'} (${user.vertical || ''})`.trim(),
    value: user.id
  };
}

/** Employee assignee / approver: Sales, Operations, Inventory only. keepIds stay visible on edit. */
export function subtaskStaffUserOptions(users = [], keepIds = []) {
  const keep = new Set(
    (Array.isArray(keepIds) ? keepIds : [keepIds])
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id) && id > 0)
  );
  const options = [];
  const seen = new Set();
  for (const user of users || []) {
    if (!user?.id || seen.has(user.id)) continue;
    if (!isSubtaskStaffVertical(user) && !keep.has(Number(user.id))) continue;
    seen.add(user.id);
    options.push(staffOptionFromUser(user));
  }
  return options;
}
